import React, { useRef, useCallback } from 'react';
import { UseFormSearch } from '@gp/pages/Pipeline/ProjectDetails/components/GameOverviewEdit/Components/UseFormSearch';
import { useIntl } from 'umi';
import { useSmartFillFormConfig } from '../../hooks/useSmartFillFormConfig';
import { RowColType } from '../../constants';
import './index.scss';

interface ISmartFillFormProps {
  /** 类型：行或列 */
  type: RowColType;
  /** 是否英文环境 - 已弃用，通过 useIntl 内部获取 */
  isEn?: boolean;
  /** 确认回调 */
  onConfirm: (values: any) => void;
  /** 取消/关闭回调 */
  onCancel: () => void;
}

/**
 * 智能填充表单组件
 * 用于 Popover 弹层内的表单，根据行/列类型显示不同字段
 */
export const SmartFillForm: React.FC<ISmartFillFormProps> = ({
  type,
  onConfirm,
  onCancel,
}) => {
  const { formatMessage } = useIntl();
  const searchFormRef = useRef<any>();
  const { config } = useSmartFillFormConfig(type);

  const handleSubmit = useCallback(
    (values: any) => {
      onConfirm(values);
      onCancel();
    },
    [type, onConfirm, onCancel],
  );

  // 使用 useFormSearch 自带的按钮
  const SearchComponent = UseFormSearch({
    config,
    getFormValue: handleSubmit,
    labelSpan: 4,
    isUnpack: false,
    initialValues:
      type === RowColType.COLUMN
        ? { column_name: '', prompt: '' }
        : { prompt: '' },
    ref: searchFormRef,
    isShowSearchBtn: true, // 显示自带按钮
    btnOkText: formatMessage({ id: 'dba_confirm' }),
    btnCancelText: formatMessage({ id: 'dba_cancel' }),
    resetCallback: onCancel,
    isDisabledSearchBtn: true,
    className: 'dba-agent-ai-table-form',
  });

  return (
    <div className="dba-smart-fill-form">
      <div className="dba-smart-fill-form__body">{SearchComponent}</div>
    </div>
  );
};

export default SmartFillForm;
